/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';

import PromotionRulesScreen from '@/screens/setting/promotion-rules/PromotionRulesScreen';
import PromotionRulesDetailScreen from '@/screens/setting/promotion-rules/PromotionRulesDetailScreen';
import PromotionRulesFormScreen from '@/screens/setting/promotion-rules/PromotionRulesFormScreen';

const Stack = createStackNavigator();

const PromotionRulesNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="PromotionRulesScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="PromotionRulesScreen"
        component={PromotionRulesScreen}
        options={() => ({
          title: setTitleHeader('Promotion Rules'),
        })}
      />
      <Stack.Screen
        name="PromotionRulesDetailScreen"
        component={PromotionRulesDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Promotion Rules';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          const goBack = () => {
            props.navigation.navigate('PromotionRulesScreen');
          };
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                notUseLastRoute={true}
                onPress={() => goBack()}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
      <Stack.Screen
        name="PromotionRulesFormScreen"
        component={PromotionRulesFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add Promotion Rules';
          let params = {};
          let isEdit = false;
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
            params = route.params;
            isEdit = true;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                // navigate() (pop) not replace() — returning to the list after
                // create preserves the migrated list instance (openChild).
                isJump={true}
                customBack={{
                  screen: isEdit
                    ? 'PromotionRulesDetailScreen'
                    : 'PromotionRulesScreen',
                  params: params,
                }}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default PromotionRulesNavigator;
